/**
 * Loading indicator (Checkup assessment flow)
 */

export function LoadingIndicator() {
  return (
    <div className="flex justify-start" data-testid="guide-loading">
      <div className="bg-card text-card-foreground px-4 py-3 rounded-2xl rounded-bl-none shadow-sm">
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce" />
          <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce [animation-delay:0.1s]" />
          <div className="w-2 h-2 bg-muted-foreground rounded-full animate-bounce [animation-delay:0.2s]" />
        </div>
      </div>
    </div>
  );
}
